import gql from 'graphql-tag';

export default gql`
  mutation createOneFavoriteTopicMutation($type: String!, $entity: MongoID!) {
    createOneFavoriteTopicMutation(type: $type, entity: $entity) {
      title
      message
    }
  }
`;
